import { observer } from 'mobx-react';
import React from 'react';
import { concat_ws, dateFormat, ReactNodeGenerator } from '../../../../lib/helpers';
import $ from 'jquery';
import { ChangeTimeSuggestionStore } from './ChangeTimeSuggestionStore';
import Swal from 'sweetalert2';
import { httpClient } from 'domain/utils/httpClient';
import { environment } from 'lib/environment';
import './ChangeTimeSuggestionScene.style.scss';
import { TooltipSpan } from 'lib/components';

@observer
export class ChangeTimeSuggestionScene extends React.Component {
  store: ChangeTimeSuggestionStore;

  constructor(props: any) {
    super(props);
    this.store = new ChangeTimeSuggestionStore(1);
  }
  componentDidMount() {
    this.store.load();
  }

  render() {
    if (!this.store.resultState?.value?.Data?.some(x => true)) {
      return null;
    }

    return (
      <div key="classroom-suggested-time" className="classroom-suggested-time">
        <div className='title-block'>
          <h3>Classroom time change suggestions</h3>
          <div className="tz-tooltip">
            <TooltipSpan className="fas fa-question-circle highlight-tooltip"
              tooltipText={'Highlighted users suggested changing the time'} />
          </div></div>
        <table >
          <thead>
            <tr>
              <th>Student</th>
              <th>Teacher</th>
              <th>Lesson</th>
              <th>Time</th>
              <th>Time suggested</th>
              <th style={{ textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.store.resultState?.value?.Data?.map((classRoom, index) => {
              return (
                <tr key="classroomRow">
                  <td className={classRoom.Student?.Id == classRoom.SuggestionUserId ? 'text-primary font-weight-bold' : ''}>{classRoom.Student?.FirstName + ' ' + classRoom.Student?.LastName}</td>
                  <td className={classRoom.Teacher?.Id == classRoom.SuggestionUserId ? 'text-primary font-weight-bold' : ''}>{classRoom.Teacher?.FirstName + ' ' + classRoom.Teacher?.LastName}</td>
                  <td>{classRoom.Lesson?.Name}</td>
                  <td>{dateFormat(classRoom.ScheduledStartTime, 'wymdhm', true)}</td>
                  <td>{dateFormat(classRoom.SuggestionStartTime, 'wymdhm', true)}</td>
                  <td className='action-block'>
                    <i onClick={() => this.onSubmitClick(classRoom.Id, "approve")} className="fa fa-check text-primary" />
                    <i onClick={() => this.onSubmitClick(classRoom.Id, "decline")} className="fa fa-times text-danger" />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  async onSubmitClick(roomId: number, action: string) {
    let url = action == "approve" ? `${environment.apiServer}/teacher/classroom-approve-time` :
      `${environment.apiServer}/administrator/classroom-decline-time`;
    const request: ClassroomAcceptTimeRequest = {
      ClassRoomId: roomId,
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    Swal.fire({ icon: 'success' });
    this.store.load();
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
interface ClassroomAcceptTimeRequest {
  ClassRoomId: number;
}